(function() {
  'use strict';

  angular.module('app.shared').factory('WorkgroupService', WorkgroupService);

  WorkgroupService.$inject = ['APP_CONSTANTS', 'ApiCaller', '$filter', '$q'];

  function WorkgroupService(APP_CONSTANTS, ApiCaller, $filter, $q) {
    var self = this;

    self.fetchProductWorkgroups = fetchProductWorkgroups;

    function fetchProductWorkgroups(productId) {
      var deferred = $q.defer();
      var url = $filter('sprintf')(
        APP_CONSTANTS.productWorkgroups,
        APP_CONSTANTS.rootUrl,
        productId
      );

      ApiCaller.apiGet(url)
        .then(function(result) {
          deferred.resolve(result);
        })
        .catch(function(error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    return self;
  }
})();
